import PropTypes from 'prop-types';
import React, { createContext, useContext, useState, useEffect } from 'react';

const MobileContext = createContext();

export const useMobile = () => {
	const context = useContext(MobileContext);
	if (!context) {
		throw new Error('useMobile must be used within a MobileProvider');
	}
	return context;
};

export const MobileProvider = ({ children }) => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkIsMobile = () => {
			const userAgent = navigator.userAgent || navigator.vendor || window.opera;

			const mobileRegex =
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i;

			// const screenWidth = window.innerWidth;
			// const isSmallScreen = screenWidth <= 768;

			const mobileDetected = mobileRegex.test(userAgent);

			setIsMobile(mobileDetected);
		};

		checkIsMobile();

		window.addEventListener('resize', checkIsMobile);

		return () => {
			window.removeEventListener('resize', checkIsMobile);
		};
	}, []);

	return (
		<MobileContext.Provider value={{ isMobile }}>
			{children}
		</MobileContext.Provider>
	);
};

MobileProvider.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired
};
